/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccE2eFixtureResetAdvancedDetailsRequest
 */
export interface PccE2eFixtureResetAdvancedDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof PccE2eFixtureResetAdvancedDetailsRequest
     */
    mode: PccE2eFixtureResetAdvancedDetailsRequestModeEnum;
}


/**
 * @export
 */
export const PccE2eFixtureResetAdvancedDetailsRequestModeEnum = {
    AdvancedDetailsOnly: 'advanced_details_only'
} as const;
export type PccE2eFixtureResetAdvancedDetailsRequestModeEnum = typeof PccE2eFixtureResetAdvancedDetailsRequestModeEnum[keyof typeof PccE2eFixtureResetAdvancedDetailsRequestModeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetAdvancedDetailsRequest interface.
 */
export function instanceOfPccE2eFixtureResetAdvancedDetailsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mode" in value;

    return isInstance;
}

export function PccE2eFixtureResetAdvancedDetailsRequestFromJSON(json: any): PccE2eFixtureResetAdvancedDetailsRequest {
    return PccE2eFixtureResetAdvancedDetailsRequestFromJSONTyped(json, false);
}

export function PccE2eFixtureResetAdvancedDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetAdvancedDetailsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mode': json['mode'],
    };
}

export function PccE2eFixtureResetAdvancedDetailsRequestToJSON(value?: PccE2eFixtureResetAdvancedDetailsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mode': value.mode,
    };
}

